import { render, staticRenderFns } from "./TetraChat.vue?vue&type=template&id=f233e398&scoped=true&lang=pug"
import script from "./TetraChat.vue?vue&type=script&lang=js"
export * from "./TetraChat.vue?vue&type=script&lang=js"
import style0 from "./TetraChat.vue?vue&type=style&index=0&id=f233e398&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f233e398",
  null
  
)

export default component.exports